import React from "react";

const HomeRedIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5059_43592)">
        <path
          d="M8.84996 12.4029V7.74615C8.84996 7.59177 8.78863 7.44372 8.67947 7.33455C8.57031 7.22539 8.42225 7.16406 8.26787 7.16406H5.93951C5.78513 7.16406 5.63708 7.22539 5.52791 7.33455C5.41875 7.44372 5.35742 7.59177 5.35742 7.74615V12.4029"
          stroke="#D95656"
          strokeWidth="1.16418"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.86523 6.00075C1.86519 5.8314 1.9021 5.66408 1.97338 5.51046C2.04466 5.35684 2.14859 5.22063 2.27794 5.11131L6.35256 1.61878C6.56269 1.44118 6.82892 1.34375 7.10404 1.34375C7.37916 1.34375 7.64539 1.44118 7.85552 1.61878L11.9301 5.11131C12.0595 5.22063 12.1634 5.35684 12.2347 5.51046C12.306 5.66408 12.3429 5.8314 12.3428 6.00075V11.2396C12.3428 11.5483 12.2202 11.8444 12.0019 12.0627C11.7835 12.2811 11.4874 12.4037 11.1787 12.4037H3.02941C2.72065 12.4037 2.42454 12.2811 2.20621 12.0627C1.98789 11.8444 1.86523 11.5483 1.86523 11.2396V6.00075Z"
          stroke="#D95656"
          strokeWidth="1.16418"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5059_43592">
          <rect
            width="13.9701"
            height="13.9701"
            fill="white"
            transform="translate(0.119141 0.179688)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HomeRedIcon;
